import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    en: {
        translation: {
            "dashboard": "Dashboard",
            "vehicles": "Vehicles",
            "clients": "Clients",
            "reservations": "Reservations",
            "rental": "Rental",
            "history": "History",
            "maintenance": "Maintenance",
            "calendar": "Calendar",
            "finance": "Finance",
            "vehicle_stats": "Vehicle Stats",
            "general_stats": "General Stats",
            "account": "Account",
            "logout": "Logout",
            "admin": "Administrator",
            "employee": "Employee",
            "total_fleet": "Total Fleet",
            "active_alerts": "Active Alerts",
            "revenue_7d": "Revenue (7d)",
            "global_balance": "Global Balance",
            "revenue_growth": "Revenue Growth (Last 7 Days)",
            "fleet_status": "Fleet Status",
            "maintenance_management": "Maintenance Management",
            "maintenance_desc": "Track and plan your fleet's maintenance",
            "technical_visits": "Technical Visits",
            "insurances": "Insurances",
            "oil_changes": "Oil Changes",
            "distributions": "Distributions",
            "current_mileage": "Current Mileage",
            "search_vehicle": "Search vehicle...",
            "all_vehicles_filter": "All vehicles",
            "expired_deadlines": "Expired deadlines",
            "recorded_vehicles": "Recorded vehicles",
            "upcoming_visits": "Upcoming visits",
            "quick_actions": "Quick Actions",
            "maintenance_report": "Maintenance Alert Report",
            "urgent": "URGENT",
            "reservation_calendar": "Reservation Calendar",
            "filters": "Filters",
            "all_statuses_filter": "All statuses",
            "today": "Today",
            "month_view": "Month",
            "week_view": "Week",
            "day_view": "Day",
            "list_view": "List",
            "medium": "MEDIUM",
            "overdue": "Overdue",
            "departures": "Departures",
            "returns": "Returns",
            "available": "Available",
            "reserved": "Reserved",
            "ready_to_use": "cars ready to use",
            "need_attention": "urgent needing attention",
            "received_today": "Payments received today",
            "balance_diff": "Inflow/Outflow difference",
            "refresh": "Refresh",
            "new_reservation": "New Reservation",
            "insurance": "Insurance",
            "oil_change": "Oil Change",
            "tech_visit": "Tech Visit",
            "expired": "Expired",
            "late": "Late",
            "overdue_short": "Overdue",
            "remaining_days": "days left",
            "remaining_km": "km left",
            "details": "Details",
            "close": "Close",
            "client_dossier": "Client Dossier",
            "assigned_vehicle": "Assigned Vehicle",
            "planning": "Planning",
            "departure": "Departure",
            "return": "Return",
            "km_departure": "Departure Km",
            "status": "Status",
            "manage_fleet": "Manage your fleet and reservations in real time.",
            "unavailable": "Unavailable",
            "new_transaction": "New Transaction",
            "manage_categories": "Manage Categories",
            "new_vehicle": "New Vehicle",
            "search_vehicles_placeholder": "Search vehicles (brand, model, license plate, chassis...)",
            "all_status": "All status",
            "sort_by_brand": "Sort by brand",
            "sort_by_price": "Sort by price",
            "sort_by_year": "Sort by year",
            "search_results": "Search results",
            "vehicle_found": "vehicle found",
            "vehicles_found": "vehicles found",
            "no_vehicle_found": "No vehicle found",
            "add_first_vehicle_desc": "Start by adding your first vehicle",
            "add_vehicle": "Add a vehicle",
            "no_results": "No results",
            "no_matching_vehicles": "No vehicle matches your search criteria",
            "reset_filters": "Reset filters",
            "delete_vehicle_title": "Delete Vehicle",
            "delete_vehicle_confirm": "Are you sure you want to delete this vehicle? This action is irreversible and will delete all associated data.",
            "cancel": "Cancel",
            "delete": "Delete",
            "per_day": "/day",
            "unknown_brand": "Unknown brand",
            "unknown_model": "Unknown model",
            "unknown_version": "Unknown version",
            "not_available_short": "N/A",
            "unknown_color": "Unknown color",
            "auto": "Auto",
            "manual": "Manual",
            "seats": "seats",
            "week": "Week:",
            "month": "Month:",
            "reason": "Reason:",
            "photos": "Photos",
            "edit": "Edit",
            "edit_vehicle": "Edit Vehicle",
            "general_info": "General Information",
            "tech_specs": "Technical Specifications",
            "vehicle_condition": "Vehicle Condition",
            "pricing": "Pricing",
            "insurance_info": "Insurance",
            "history_info": "History",
            "maintenance_info": "Maintenance",
            "chassis_number": "Chassis Number",
            "license_plate": "License Plate",
            "brand": "Brand",
            "model": "Model",
            "version_label": "Version",
            "year": "Year",
            "color": "Color",
            "genre": "Genre",
            "body_type": "Body Type",
            "weight": "Weight",
            "payload": "Payload",
            "prev_registration": "Previous Registration",
            "fuel": "Fuel",
            "transmission": "Transmission",
            "seats_count": "Number of Seats",
            "doors_count": "Number of Doors",
            "mileage": "Mileage",
            "power": "Power",
            "mech_state": "Mechanical State",
            "body_state": "Body State",
            "suspension_state": "Suspension State",
            "tires_state": "Tires State",
            "state_comment": "State Comment",
            "daily_price": "Daily Rental Price",
            "weekly_price": "Weekly Rental Price",
            "monthly_price": "Monthly Rental Price",
            "avail_status": "Availability Status",
            "unavail_reason": "Unavailability Reason",
            "insurance_company": "Insurance Company",
            "policy_number": "Policy Number",
            "expiration_date": "Expiration Date",
            "registration_date": "Registration Date",
            "last_tech_visit": "Last Technical Visit",
            "next_tech_visit": "Next Technical Visit",
            "last_oil_change": "Last Oil Change",
            "oil_change_mileage": "Oil Change Mileage",
            "next_oil_change_mileage": "Next Oil Change Mileage",
            "distrib_replacement_date": "Distribution Replacement Date",
            "distrib_replacement_mileage": "Distribution Replacement Mileage",
            "next_distrib_mileage": "Next Distribution Mileage",
            "equipment": "Equipment",
            "photos_docs": "Photos and Documents",
            "vehicle_photo": "Vehicle Photo",
            "registration_card": "Registration Card",
            "insurance_doc": "Insurance",
            "extra_photos": "Additional Photos",
            "click_to_upload": "Click to upload",
            "drag_drop": "or drag and drop",
            "allowed_formats": "PNG, JPG, JPEG",
            "files_selected": "file(s) selected",
            "required_fields_notice": "Required fields",
            "save_success": "Vehicle saved successfully!",
            "update_success": "Vehicle updated successfully!",
            "save_error": "Error while saving vehicle",
            "delete_photo_error": "Error while deleting photo",
            "comment_placeholder": "Comments on vehicle state...",
            "unavail_placeholder": "Unavailability reason...",
            "click_to_upload_short": "Click to upload",
            "yes_delete": "Yes, delete",

            // General
            "add": "Add",
            "adding": "Adding...",
            "error": "Error",
            "warning": "Warning",
            "success": "Success",
            "unexpected_server_response": "Unexpected server response",

            "back": "Back",
            "print": "Print",
            "print_voucher": "Print Payment Voucher",
            "created_on": "Created on",
            "actual_return": "Actual Return",
            "km_details": "Kilometer Details",
            "distance_traveled": "Distance Traveled",
            "late_penalty": "Late Penalty",
            "delete_photo": "Delete photo",
            "choose_photos": "Choose photos",
            "view_client_details": "View client details",
            "view_vehicle_details": "View vehicle details",
            "no_client_info": "No client information",
            "no_vehicle_info": "No vehicle information",

            // VoitureGallery
            "gallery_full": "Full Gallery",
            "no_photos": "No photos available",
            "main_photo_label": "Main Photo",
            "registration_card_label": "Registration Card",
            "insurance_label": "Insurance",
            "extra_photo_label": "Additional Photo",
            "supplementary": "Supplementary",
            "thumbnail": "Thumbnail",

            // AddEquipement
            "add_equipment_btn": "Add equipment",
            "equipment_placeholder": "Equipment name",
            "success_add_equip": "Equipment added successfully",
            "error_add_equip": "Error while adding equipment",

            // CategoryManager
            "manage_categories_title": "Category Management",
            "category_desc": "Organize your transaction types",
            "edit_mode_active": "Edit mode active",
            "category_name_label": "Category name",
            "category_placeholder": "Ex: Transport, Food...",
            "description_label": "Description",
            "description_placeholder": "Optional description...",
            "save_category": "Save category",
            "add_category": "Add category",
            "loading_categories": "Loading categories...",
            "no_categories_found": "No categories found",
            "empty_categories_desc": "Start by adding your first category",
            "existing_categories": "Existing categories",
            "protected_categories_count": "protected categories",
            "name_col": "Name",
            "description_col": "Description",
            "actions_col": "Actions",
            "edit_btn": "Edit",
            "delete_btn": "Delete",
            "confirm_delete_title": "Are you sure?",
            "confirm_delete_text": "Do you really want to delete this category?",
            "delete_success": "Category deleted",
            "delete_error": "Error during deletion",
            "protected_cat_error": "This category is protected and cannot be modified or deleted",
            "reserved_cat_error": "This category name is reserved and cannot be created",

            // Client Module
            "search_clients_placeholder": "Search clients (name, email, phone...)",
            "client_type_label": "Client Type",
            "all_types": "All types",
            "particulier": "Personal",
            "entreprise": "Business",

            // Reservation Module
            "reservations_management": "Reservations Management",
            "create_new_reservation": "Create a new reservation",
            "fill_reservation_details": "Fill in the reservation details",
            "success_reservation_created": "The reservation has been created successfully",
            "error_reservation_creation": "Error creating reservation",
            "understood": "Understood",
            "reservation_list": "Reservation List",
            "select_vehicle": "Select Vehicle",
            "select_client": "Select Client",
            "departure_date": "Departure Date",
            "return_date": "Return Date",
            "total_price": "Total Price",
            "advance_payment": "Advance Payment",
            "remaining_payment": "Remaining Payment",
            "status": "Status",
            "pending": "Pending",
            "confirmed": "Confirmed",
            "cancelled": "Cancelled",
            "completed": "Completed",
            "today_reservations": "Today's Reservations",
            "errors_to_fix": "Errors to fix",
            "client_vehicle_info": "Client & Vehicle Information",
            "search_client_placeholder": "Search a client by name or phone",
            "new_client_name_placeholder": "Or enter a client name (new client)",
            "selected_client": "Selected client",
            "client_history": "Client History",
            "departure_date_time": "Departure date and time",
            "return_date_time": "Expected return date and time",
            "select_departure_first": "Please select a departure date first",
            "base_price_day": "Base price (day)",
            "number_of_days": "Number of days",
            "total_price_before_discount": "Total price before discount",
            "departure_location": "Departure location",
            "return_location": "Return location",
            "departure_mileage": "Departure mileage",
            "pricing_payment": "Pricing and Payment",
            "discount": "Discount",
            "total_after_discount": "Total after discount",
            "initial_versement": "Initial deposit",
            "deposit_notes": "Deposit & Notes",
            "deposit": "Deposit",
            "deposit_returned": "Deposit returned",
            "remaining_amount": "Remaining Amount",
            "notes_placeholder": "Additional notes or reservation details",
            "description": "Description",
            "photos_optional": "Photos (optional)",
            "create_reservation": "Create Reservation",
            "failed_load_clients": "Failed to load clients",
            "failed_load_vehicles": "Failed to load vehicles",
            "failed_load_reservations": "Failed to load reservations",
            "success_delete_reservation": "Reservation deleted successfully",
            "error_delete_reservation": "Error deleting reservation",
            "searching": "Searching...",
            "results": "Results",
            "reservations_results_subtitle": "List of reservations based on your search criteria",
            "try_modifying_filters": "Try modifying your search criteria",
            "departure": "Departure",
            "return": "Return",
            "start_reservation": "Start Reservation",
            "january": "January", "february": "February", "march": "March", "april": "April", "may": "May", "june": "June",
            "july": "July", "august": "August", "september": "September", "october": "October", "november": "November", "december": "December",
            "sun": "Sun", "mon": "Mon", "tue": "Tue", "wed": "Wed", "thu": "Thu", "fri": "Fri", "sat": "Sat",
            "in_progress_no_select": "In progress (non-selectable)",
            "pending_with_alert": "Pending (with alert)",
            "available": "Available",
            "date_unavailable_in_progress": "Date unavailable - Reservation in progress",
            "pending_click_continue": "Pending reservation - Click to continue (with alert)",
            "select_time": "Select time",
            "pending_date_warning": "⚠️ Warning: This date is part of a pending reservation. Do you want to continue?",
            "client_required": "Client is required",
            "vehicle_required": "Vehicle is required",
            "departure_km_invalid": "Invalid departure mileage",
            "departure_date_required": "Departure date is required",
            "return_date_required": "Return date is required",
            "return_after_departure_error": "The return date/time must be after the departure date/time",
            "discount_range_error": "Discount must be between 0 and",
            "versement_min_error": "Initial deposit must be greater than 0",
            "versement_max_error": "Initial deposit cannot exceed total",
            "paid_mode_error": "For 'paid' mode, the amount paid must equal the total",
            "non_paid_mode_error": "For 'non-paid' mode, the amount paid must be 0",
            "not_defined": "Not defined",
            "at": "at",
            "error_creating_reservation": "Error during creation",
            "phone_short": "Phone",
            "upload_files": "Upload files",
            "upcoming_reservations": "Upcoming Reservations",
            "search_reservations": "Search reservations...",
            "filter_by_status": "Filter by status",
            "filter_by_date": "Filter by date",
            "mark_as_confirmed": "Mark as Confirmed",
            "mark_as_cancelled": "Mark as Cancelled",
            "mark_as_completed": "Mark as Completed",
            "view_details": "View Details",
            "edit_reservation": "Edit Reservation",
            "delete_reservation": "Delete Reservation",
            "confirm_delete_reservation": "Are you sure you want to delete this reservation?",
            "reservation_id": "Reservation ID",
            "client_details": "Client Details",
            "vehicle_details": "Vehicle Details",
            "rental_period": "Rental Period",
            "pricing": "Pricing",
            "days": "days",
            "day": "day",
            "total_amount": "Total Amount",
            "paid_amount": "Paid Amount",
            "balance_due": "Balance Due",
            "contract_generated": "Contract generated successfully",
            "generate_contract": "Generate Contract",
            "print_receipt": "Print Receipt",
            "no_reservations_found": "No reservations found",
            "all_reservations": "All Reservations",
            "reservation_history": "Reservation History",
            "active_reservations": "Active Reservations",
            "payment_status": "Payment Status",
            "paid": "Paid",
            "partial": "Partial",
            "unpaid": "Unpaid",
            "loading_reservations": "Loading reservations...",
            "save_reservation": "Save Reservation",
            "updating_reservation": "Updating reservation...",
            "reservation_number": "Reservation #",
            "contract_number": "Contract #",
            "pickup_location": "Pickup Location",
            "return_location": "Return Location",
            "notes": "Notes",
            "additional_services": "Additional Services",
            "insurance": "Insurance",
            "baby_seat": "Baby Seat",
            "gps": "GPS",
            "additional_driver": "Additional Driver",
            "daily_rate": "Daily Rate",
            "extension": "Extension",
            "extend_reservation": "Extend Reservation",
            "new_return_date": "New Return Date",
            "cost": "Cost",
            "reason": "Reason",
            "apply": "Apply",
            "new_client": "New Client",
            "edit_client": "Edit Client",
            "client_list": "Client List",
            "client_found": "client found",
            "clients_found": "clients found",
            "no_client_found": "No client found",
            "add_first_client_desc": "Start by adding your first client",
            "add_client_btn": "Add a client",
            "client_col": "Client",
            "contact_col": "Contact",
            "type_col": "Type",
            "license_col": "License",
            "delete_client_title": "Delete client",
            "delete_client_confirm": "Are you sure you want to delete this client? This action is irreversible.",
            "delete_success_client": "Client deleted successfully",
            "error_delete_client": "Error while deleting client",
            "personal_info": "Personal Information",
            "main_driver": "Main Driver",
            "second_driver": "Second Driver",
            "last_name": "Last Name",
            "first_name": "First Name",
            "phone": "Phone",
            "address": "Address",
            "dob": "Date of Birth",
            "pob": "Place of Birth",
            "driving_license": "Driving License",
            "license_number": "License Number",
            "issue_date": "Issue Date",
            "issue_place": "Issue Place",
            "validity": "Validity",
            "issued_at": "Issued at",
            "passport": "Passport",
            "passport_number": "Passport Number",
            "passport_issue_date": "Passport Issue Date",
            "passport_issue_place": "Passport Issue Place",
            "license_photo": "License Photo",
            "click_to_upload_client": "Click to upload",
            "success_add_client": "Client added successfully!",
            "success_update_client": "Client updated successfully!",
            "full_dossier": "Full Dossier",
            "sync_success": "Data synced successfully",
            "no_image_available": "No image available",
            "modifier_le_dossier": "Modify Dossier",
            "currency": "DA",
            "modify": "Modify",
            "save": "Save",
            "loading": "Loading...",
            "error_loading": "Error during loading",
            "action": "Action",
            "view_all": "View All",
            "manage_reservation": "Manage Reservation",
            "client_vehicle": "Client & Vehicle",
            "reservation_details": "Reservation Details",
            "dates_locations": "Dates & Locations",
            "deposit_caution": "Deposit & Caution",
            "saving": "Saving...",
            "error_details": "Impossible to load details",
            "reservation_not_found": "Reservation not found",
            "start_reservation_title": "Start Reservation",
            "client_info": "Client Information",
            "vehicle_info": "Vehicle Information",
            "locations": "Locations",
            "dates_prices": "Dates & Prices",
            "agent": "Agent",
            "return_mileage": "Return Mileage",
            "late_return_detected": "Late return detected",
            "early_return": "Early return",
            "total_adjustable": "Total (adjustable)",
            "full_payment_notice": "Reservation will be marked as paid in full",
            "overdue_status": "Overdue",
            "rental_status": "Rental",
            "returns_status": "Returns",
            "weekly": "Weekly",
            "monthly": "Monthly",
            "unauthorized_access": "Unauthorized access",
            "insufficient_permissions": "You don't have enough permissions",
            "search_results_count": "result(s) found",
            "overdue_return": "Overdue Return",
            "success_update_reservation": "Reservation updated successfully",
            "error_update_reservation": "Error updating reservation",
            "confirm_complete_reservation": "Are you sure you want to complete this reservation?",
            "confirm_start_reservation": "Are you sure you want to start this reservation?",
            "payment_mode_modified": "Payment mode modified",
            "total_increased_from": "The total increased from",
            "to": "to",
            "payment_mode_auto_changed": "The payment mode was automatically changed to 'Versement' with an initial deposit.",
            "date_unavailable": "Date not available",
            "continue": "Continue",
            "confirm": "Confirm",
            "client_required": "Client is required",
            "vehicle_required": "Vehicle is required",
            "departure_km_invalid": "Invalid departure mileage",
            "departure_date_required": "Departure date is required",
            "return_date_required": "Return date is required",
            "return_after_departure_error": "Return date must be after departure date",
            "discount_range_error": "Discount between 0 and",
            "versement_min_error": "Deposit must be greater than 0",
            "versement_max_error": "Deposit cannot exceed total",
            "paid_mode_error": "Amount must equal total for 'paid' mode",
            "success_delete_photo": "Photo deleted successfully",
            "error_delete_photo": "Error deleting photo",
            "edit_reservation_ongoing": "Edit Ongoing Reservation",
            "edit_reservation_desc": "Update existing reservation details",
            "select_client_placeholder": "-- Select a client --",
            "select_vehicle_placeholder": "-- Select a vehicle --",
            "search_client_or_enter": "Or enter a client name",
            "description": "Description",
            "reservation_started": "Reservation started",
            "status_now_in_progress": "The status is now 'In Progress'.",
            "error_loading_details": "Error loading details",
            "loading_details": "Loading details...",
            "client_info": "Client Information",
            "vehicle_info": "Vehicle Information",
            "locations": "Locations",
            "dates_tarifs": "Dates & Tarifs",
            "km_departure_label": "Departure KM",
            "start_reservation_btn": "Start Reservation",
            "close_reservation_title": "Close Reservation",
            "return_mileage_label": "Return Mileage",
            "late_return_detected": "Late return detected. Please enter the late fee amount:",
            "early_return_detected": "Early return detected. New total:",
            "new_total": "New total",
            "total_modifiable": "Total (modifiable)",
            "reservation_fully_paid": "The reservation will be marked as fully paid",
            "remaining_before_closing": "Remaining to pay before closing",
            "close_reservation_btn": "Close Reservation",
            "file": "file",
            "files": "files",
            "selected": "selected",
            "valid_km_return_error": "Please enter a valid return mileage.",
            "weekly_caps": "WEEKLY",
            "monthly_caps": "MONTHLY",
            "filters": "Filters",
            "filter_reservations": "Filter reservations",
            "clear_all": "Clear all",
            "all_clients": "All clients",
            "all_vehicles": "All vehicles",
            "departure_date_from": "Departure date (from)",
            "departure_date_to": "Departure date (to)",
            "results_description": "List of reservations based on your search criteria",
            "try_different_filters": "Try to modify your search criteria",
            "departure_point": "Departure:",
            "return_point": "Return:",
            "confirm_delete_title": "Are you sure?",
            "confirm_delete_text": "This reservation will be permanently deleted.",
            "deleted_title": "Deleted!",
            "deleted_success_text": "The reservation has been deleted successfully.",
            "delete_error_text": "An error occurred while deleting the reservation.",
            "delete_error_short": "Error while deleting reservation.",
            "confirm_late_closing": "🚨 The car is returned late. Do you confirm closing with fees?",
            "complete_error": "❌ Unable to complete the reservation.",
            "analytics_dashboard": "Analytical Dashboard",
            "fleet_stats_desc": "Complete statistics of your car fleet",
            "today": "Today",
            "this_week": "This week",
            "this_month": "This month",
            "this_year": "This year",
            "financial_stats": "Financial Statistics",
            "performance": "Performance",
            "encaissements": "Inflows",
            "decaissements": "Outflows",
            "net_balance": "Net Balance",
            "expense_income_ratio": "Expense/Income Ratio",
            "financial_evolution": "Financial Evolution",
            "cumulative_balance": "Cumulative Balance",
            "max_inflow_day": "Day with maximum inflow",
            "max_outflow_day": "Day with maximum outflow",
            "on_the": "On the",
            "record": "Record",
            "reservation_stats": "Reservation Statistics",
            "top_5_rented_cars": "Top 5 rented cars",
            "locations_count": "rentals",
            "top_5_least_used_cars": "5 least used cars",
            "top_5_vip_clients": "Top 5 VIP clients",
            "average_rental_duration": "Average rental duration",
            "cancellation_rate": "Cancellation rate",
            "avg_on_all_reservations": "Average on all reservations",
            "percentage_cancelled_reservations": "Percentage of cancelled reservations",
            "loading_stats": "Loading statistics...",
            "increase": "Increase",
            "decrease": "Decrease",
            "no_data_available": "No data available",
            "no_records_found_section": "No records found for this section.",
            "finance_management": "Finance Management",
            "new_transaction": "New Transaction",
            "edit_transaction": "Edit Transaction",
            "transaction_added_success": "Transaction added successfully!",
            "transaction_updated_success": "Transaction updated successfully!",
            "transaction_deleted_success": "Transaction deleted successfully!",
            "confirm_delete_transaction": "Are you sure you want to delete this transaction?",
            "amount_required": "Amount is required and must be a valid number.",
            "type_date_required": "Type and date are required.",
            "electricity": "Electricity",
            "water": "Water",
            "internet": "Internet",
            "cleaning_lady": "Cleaning lady",
            "agent_payment": "Agent payment",
            "reservation": "Reservation",
            "investment": "Investment",
            "other": "Other",
            "justification": "Justification",
            "view_justification": "View Justification",
            "download_success": "Download successful",
            "download_failed": "Download failed",
            "no_transaction_found": "No transactions found.",
            "amount_da": "Amount (DA)",
            "receipt": "Receipt",
            "all": "All",
            "showing_results": "Showing {{start}} to {{end}} of {{total}} results",
            "previous": "Previous",
            "next": "Next",

            // CarTransactions page
            "transactions_management": "Transaction Management",
            "manage_vehicle_transactions": "Manage revenue and expenses for your vehicle",
            "statistics_btn": "Statistics",
            "categories_btn": "Categories",
            "select_vehicle_label": "Select a vehicle",
            "choose_vehicle": "Choose a vehicle",
            "total_label": "Total",
            "search_transactions": "Search transactions (description, category...)",
            "all_types": "All types",
            "encaissement_label": "Inflows",
            "decaissement_label": "Outflows",
            "all_categories": "All categories",
            "start_date": "Start date",
            "end_date": "End date",
            "reset": "Reset",
            "transactions_title": "Transactions",
            "no_vehicle_selected_msg": "No vehicle selected",
            "select_vehicle_to_view": "Please select a vehicle to view its transactions",
            "no_transactions_msg": "No transactions",
            "add_first_transaction_desc": "Start by adding your first transaction for this vehicle",
            "add_transaction_btn": "Add a transaction",
            "no_search_results": "No results",
            "no_matching_transactions": "No transaction matches your search criteria",
            "reset_transaction_filters": "Reset filters",
            "date_col": "Date",
            "type_col": "Type",
            "category_col": "Category",
            "amount_col": "Amount",
            "actions_col": "Actions",
            "uncategorized": "Uncategorized",
            "edit_transaction_btn": "Edit",
            "delete_transaction_btn": "Delete",
            "delete_transaction_title": "Delete transaction",
            "delete_transaction_confirm": "Are you sure you want to delete this transaction? This action is irreversible.",
            "encaissement_type": "Inflow",
            "decaissement_type": "Outflow",
            "transaction_form_title_new": "New Transaction",
            "transaction_form_title_edit": "Edit Transaction",
            "transaction_type_label": "Transaction type *",
            "transaction_category_label": "Category",
            "transaction_amount_label": "Amount (DA) *",
            "transaction_description_label": "Description",
            "transaction_date_label": "Date *",
            "transaction_submit_create": "Add Transaction",
            "transaction_submit_update": "Update Transaction",
            "creating": "Creating...",
            "updating": "Updating...",
            "manage_categories_title_modal": "Category Management",
            "total_transactions": "total transactions",
            "page_label": "Page",

            // Historique page
            "reservations_management_hist": "Reservation Management",
            "filter_reservations_hist": "Filter Reservations",
            "clear_all_filters": "Clear all",
            "all_statuses": "All statuses",
            "status_pending": "Pending",
            "status_in_progress": "In progress",
            "status_done": "Completed",
            "status_canceled": "Cancelled",
            "status_overdue": "Overdue",
            "search_btn": "Search",
            "searching_label": "Searching...",
            "results_title": "Results",
            "results_subtitle": "List of reservations based on your search criteria",
            "no_reservations_found_hist": "No reservations found",
            "try_modify_filters": "Try modifying your search criteria",
            "id_col": "ID",
            "vehicle_col": "Vehicle",
            "dates_col": "Dates",
            "price_col": "Price",
            "date_departure_label": "Departure:",
            "date_return_label": "Return:",
            "total_price_label": "Total:",
            "paid_label": "Paid:",
            "view_details_btn": "View details",

            // Account page
            "my_account": "My Account",
            "save_btn": "Save",
            "current_password": "Current password",
            "new_password": "New password",
            "change_password": "Change password",
            "updating_password": "Updating...",
            "update_password_btn": "Update password",
            "agency_info": "Agency Information",
            "agency_name": "Agency name",
            "location_label": "Location",
            "phone1": "Phone 1",
            "phone2": "Phone 2",
            "email": "Email",
            "employee_management": "Employee Management",
            "new_employee": "New Employee",
            "no_employees_found": "No employees found",
            "username_col": "Username",
            "role_col": "Role",
            "created_at_col": "Creation Date",
            "edit_employee": "Edit employee",
            "delete_employee": "Delete employee",
            "confirm_delete_employee": "Are you sure you want to delete this employee?",
            "employee_updated": "Employee updated successfully",
            "employee_created": "Employee created successfully",
            "employee_deleted": "Employee deleted successfully",
            "error_loading_data": "Error loading data",
            "error_loading_employees": "Error loading employees",
            "password_fields_required": "Please fill in both password fields",
            "password_updated": "Password updated successfully",
            "info_updated": "Information updated successfully",
            "username_updated": "Username updated",
            "update_error": "Error updating",
            "operation_error": "Error during operation",
            "password_label": "Password",
            "role_employee": "Employee",
            "role_admin": "Administrator",
            "creating_label": "Processing..."
        }
    },
    fr: {
        translation: {
            "dashboard": "Tableau de bord",
            "vehicles": "Gestion des véhicules",
            "clients": "Clients",
            "reservations": "Réservations",
            "rental": "Location",
            "history": "Historique",
            "maintenance": "Entretien",
            "calendar": "Calendrier",
            "finance": "Finance",
            "vehicle_stats": "Statistiques Véhicules",
            "general_stats": "Statistiques Générales",
            "account": "Compte",
            "logout": "Déconnexion",
            "admin": "Administrateur",
            "employee": "Employé",
            "total_fleet": "Flotte Totale",
            "active_alerts": "Alertes Actives",
            "revenue_7d": "Recette (7j)",
            "global_balance": "Solde Global",
            "revenue_growth": "Croissance des Revenus (7 derniers jours)",
            "fleet_status": "Statut de la Flotte",
            "maintenance_management": "Gestion des Entretiens",
            "maintenance_desc": "Suivez et planifiez les entretiens de votre flotte automobile",
            "technical_visits": "Visites Techniques",
            "insurances": "Assurances",
            "oil_changes": "Vidanges",
            "distributions": "Chaines de Distribution",
            "current_mileage": "Kilométrage actuel",
            "search_vehicle": "Rechercher véhicule...",
            "all_vehicles_filter": "Tous les véhicules",
            "expired_deadlines": "Échéances dépassées",
            "recorded_vehicles": "Véhicules enregistrés",
            "upcoming_visits": "Visites à venir",
            "quick_actions": "Actions Rapides",
            "maintenance_report": "Rapport d'Alertes Maintenance",
            "urgent": "URGENTES",
            "reservation_calendar": "Calendrier des Réservations",
            "filters": "Filtres",
            "all_statuses_filter": "Tous les statuts",
            "today": "Aujourd'hui",
            "month_view": "Mois",
            "week_view": "Semaine",
            "day_view": "Jour",
            "list_view": "Liste",
            "medium": "MOYENNES",
            "medium": "MOYENNES",
            "overdue": "En Retard",
            "departures": "Départs",
            "returns": "Retours",
            "available": "Disponibles",
            "reserved": "Réservés",
            "need_attention": "urgentes nécessitant une attention",
            "received_today": "Paiement reçus aujourd'hui",
            "balance_diff": "Différence encaissement/décaissement",
            "refresh": "Actualiser",
            "new_reservation": "Nouvelle Réservation",
            "insurance": "Assurance",
            "oil_change": "Vidange",
            "tech_visit": "Visite Tech",
            "expired": "Expiré",
            "late": "En retard",
            "overdue_short": "Dépassée",
            "remaining_days": "j restants",
            "remaining_km": "km restants",
            "details_reservation": "Détails de Réservation",
            "close": "Fermer",
            "client_dossier": "Dossier Client",
            "assigned_vehicle": "Véhicule Assigné",
            "planning": "Planning",
            "departure": "Départ",
            "return": "Retour",
            "km_departure": "Km départ",
            "status": "Statut",
            "manage_fleet": "Gérez votre flotte et vos réservations en temps réel.",
            "manage_vehicles": "Gestion des Véhicules",
            "fleet_mgmt_desc": "Gérez votre parc automobile efficacement",
            "total": "Total",
            "unavailable": "Indisponibles",
            "new_transaction": "Nouvelle Transaction",
            "manage_categories": "Gérer les Catégories",
            "new_vehicle": "Nouveau Véhicule",
            "search_vehicles_placeholder": "Rechercher véhicules (marque, modèle, matricule, châssis...)",
            "all_status": "Tous les statuts",
            "sort_by_brand": "Trier par marque",
            "sort_by_price": "Trier par prix",
            "sort_by_year": "Trier par année",
            "search_results": "Résultats de la recherche",
            "vehicle_found": "véhicule trouvé",
            "vehicles_found": "véhicules trouvés",
            "no_vehicle_found": "Aucun véhicule trouvé",
            "add_first_vehicle_desc": "Commencez par ajouter votre premier véhicule",
            "add_vehicle": "Ajouter un véhicule",
            "no_results": "Aucun résultat",
            "no_matching_vehicles": "Aucun véhicule ne correspond à vos critères de recherche",
            "reset_filters": "Réinitialiser les filtres",
            "delete_vehicle_title": "Supprimer le véhicule",
            "delete_vehicle_confirm": "Êtes-vous sûr de vouloir supprimer ce véhicule? Cette action est irréversible et supprimera toutes les données associées.",
            "cancel": "Annuler",
            "delete": "Supprimer",
            "per_day": "/jour",
            "unknown_brand": "Marque inconnue",
            "unknown_model": "Modèle inconnu",
            "unknown_version": "Version inconnue",
            "not_available_short": "N/A",
            "unknown_color": "Couleur inconnue",
            "auto": "Auto",
            "manual": "Manuelle",
            "seats": "places",
            "week": "Semaine:",
            "month": "Mois:",
            "reason": "Motif:",
            "photos": "Photos",
            "edit": "Modifier",
            "essence": "Essence",
            "diesel": "Diesel",
            "gpl": "GPL",
            "electric": "Électrique",
            "hybrid": "Hybride",
            "edit_vehicle": "Modifier Véhicule",
            "general_info": "Informations Générales",
            "tech_specs": "Caractéristiques Techniques",
            "vehicle_condition": "État du Véhicule",
            "pricing": "Tarification",
            "insurance_info": "Assurance",
            "history_info": "Historique",
            "maintenance_info": "Entretien",
            "chassis_number": "Numéro de Châssis",
            "license_plate": "Matricule",
            "brand": "Marque",
            "model": "Modèle",
            "version_label": "Version",
            "year": "Année",
            "color": "Couleur",
            "genre": "Genre",
            "body_type": "Carrosserie",
            "weight": "Poids",
            "payload": "Charge Utile",
            "prev_registration": "Précédent Immatriculation",
            "fuel": "Carburant",
            "transmission": "Boîte de Vitesse",
            "seats_count": "Nombre de Places",
            "doors_count": "Nombre de Portes",
            "mileage": "Kilométrage",
            "power": "Puissance",
            "mech_state": "État Mécanique",
            "body_state": "État Carrosserie",
            "suspension_state": "État Suspension",
            "tires_state": "État Pneus",
            "state_comment": "Commentaire État",
            "daily_price": "Prix Location Jour",
            "weekly_price": "Prix Location Semaine",
            "monthly_price": "Prix Location Mois",
            "avail_status": "Statut Disponibilité",
            "unavail_reason": "Motif Indisponibilité",
            "insurance_company": "Compagnie d'Assurance",
            "policy_number": "Numéro de Police",
            "expiration_date": "Date d'Expiration",
            "registration_date": "Date de mise en circulation",
            "last_tech_visit": "Dernière Visite Tech",
            "next_tech_visit": "Prochaine Visite Tech",
            "last_oil_change": "Dernière Vidange",
            "oil_change_mileage": "Kilométrage Vidange",
            "next_oil_change_mileage": "Prochain Kilométrage Vidange",
            "distrib_replacement_date": "Date Remplacement Distribution",
            "distrib_replacement_mileage": "Kilométrage Remplacement Distribution",
            "next_distrib_mileage": "Prochain Kilométrage Distribution",
            "equipment": "Équipements",
            "photos_docs": "Photos et Documents",
            "vehicle_photo": "Photo du véhicule",
            "registration_card": "Carte grise",
            "insurance_doc": "Assurance",
            "extra_photos": "Photos supplémentaires",
            "click_to_upload": "Cliquez pour téléverser",
            "drag_drop": "ou glisser-déposer",
            "allowed_formats": "PNG, JPG, JPEG",
            "files_selected": "nouveau(x) fichier(s) sélectionné(s)",
            "required_fields_notice": "Champs obligatoires",
            "save_success": "Véhicule ajouté avec succès !",
            "update_success": "Véhicule mis à jour avec succès !",
            "save_error": "Erreur lors de l'enregistrement du véhicule",
            "delete_photo_error": "Erreur lors de la suppression de la photo",
            "comment_placeholder": "Commentaires sur l'état du véhicule...",
            "unavail_placeholder": "Motif d'indisponibilité...",
            "click_to_upload_short": "Cliquez pour téléverser",

            // General
            "add": "Ajouter",
            "adding": "Ajout...",

            "back": "Retour",
            "print": "Imprimer",
            "print_voucher": "Imprimer le bon de paiement",
            "created_on": "Créé le",
            "actual_return": "Retour effectif",
            "km_details": "Détails du kilométrage",
            "distance_traveled": "Distance parcourue",
            "late_penalty": "Pénalité de retard",
            "delete_photo": "Supprimer la photo",
            "choose_photos": "Choisir des photos",
            "view_client_details": "Voir détails client",
            "view_vehicle_details": "Voir détails véhicule",
            "no_client_info": "Aucune information client",
            "no_vehicle_info": "Aucune information véhicule",

            // VoitureGallery
            "gallery_full": "Galerie complète",
            "no_photos": "Aucune photo disponible",
            "main_photo_label": "Photo principale",
            "registration_card_label": "Carte grise",
            "insurance_label": "Assurance",
            "extra_photo_label": "Photo supplémentaire",
            "supplementary": "Supplémentaire",
            "thumbnail": "Miniature",

            // AddEquipement
            "add_equipment_btn": "Ajouter un équipement",
            "equipment_placeholder": "Nom de l'équipement",
            "success_add_equip": "Équipement ajouté avec succès",
            "error_add_equip": "Erreur lors de l'ajout de l'équipement",

            // CategoryManager
            "manage_categories_title": "Gestion des Catégories",
            "category_desc": "Organisez vos types de transactions",
            "edit_mode_active": "Mode édition activé",
            "category_name_label": "Nom de la catégorie",
            "category_placeholder": "Ex: Transport, Alimentation...",
            "description_label": "Description",
            "description_placeholder": "Description optionnelle...",
            "save_category": "Enregistrer la catégorie",
            "add_category": "Ajouter une catégorie",
            "loading_categories": "Chargement des catégories...",
            "no_categories_found": "Aucune catégorie trouvée",
            "empty_categories_desc": "Commencez par ajouter votre première catégorie",
            "existing_categories": "Catégories existantes",
            "protected_categories_count": "catégories protégées",
            "name_col": "Nom",
            "description_col": "Description",
            "actions_col": "Actions",
            "edit_btn": "Éditer",
            "delete_btn": "Supprimer",
            "confirm_delete_title": "Êtes-vous sûr ?",
            "confirm_delete_text": "Voulez-vous vraiment supprimer cette catégorie ?",
            "delete_success": "Catégorie supprimée",
            "delete_error": "Erreur lors de la suppression",
            "protected_cat_error": "Cette catégorie est protégée et ne peut pas être modifiée ou supprimée",
            "reserved_cat_error": "Ce nom de catégorie est réservé et ne peut pas être créé",
            "yes_delete": "Oui, supprimer",
            "error": "Erreur",
            "warning": "Attention",
            "success": "Succès",
            "unexpected_server_response": "Réponse inhabituelle du serveur",

            // Client Module
            "search_clients_placeholder": "Rechercher clients (nom, email, téléphone...)",
            "client_type_label": "Type de client",
            "all_types": "Tous types",
            "particulier": "Particulier",
            "entreprise": "Entreprise",

            // Reservation Module
            "reservations_management": "Gestion des Réservations",
            "create_new_reservation": "Créer une nouvelle réservation",
            "fill_reservation_details": "Remplissez les détails de la réservation",
            "success_reservation_created": "La réservation a été créée avec succès",
            "error_reservation_creation": "Erreur lors de la création de la réservation",
            "understood": "Compris",
            "reservation_list": "Liste des Réservations",
            "select_vehicle": "Sélectionner un véhicule",
            "select_client": "Sélectionner un client",
            "departure_date": "Date de départ",
            "return_date": "Date de retour",
            "total_price": "Prix Total",
            "advance_payment": "Avance",
            "remaining_payment": "Reste à payer",
            "status": "Statut",
            "pending": "En attente",
            "confirmed": "Confirmée",
            "cancelled": "Annulée",
            "completed": "Terminée",
            "today_reservations": "Réservations d'aujourd'hui",
            "errors_to_fix": "Erreurs à corriger",
            "client_vehicle_info": "Informations Client & Véhicule",
            "search_client_placeholder": "Rechercher un client par nom ou téléphone",
            "new_client_name_placeholder": "Ou saisir un nom de client (nouveau client)",
            "selected_client": "Client sélectionné",
            "client_history": "Historique du Client",
            "departure_date_time": "Date et heure de départ",
            "return_date_time": "Date et heure de retour prévue",
            "select_departure_first": "Veuillez d'abord sélectionner une date de départ",
            "base_price_day": "Prix de base (jour)",
            "number_of_days": "Nombre de jours",
            "total_price_before_discount": "Prix total avant remise",
            "departure_location": "Lieu de départ",
            "return_location": "Lieu de retour",
            "departure_mileage": "Kilométrage de départ",
            "pricing_payment": "Tarification et Paiement",
            "discount": "Remise",
            "total_after_discount": "Total après remise",
            "initial_versement": "Versement initial",
            "deposit_notes": "Caution et Notes",
            "deposit": "Caution",
            "deposit_returned": "Caution rendu",
            "notes_placeholder": "Notes supplémentaires ou détails de la réservation",
            "photos_optional": "Photos (facultatif)",
            "create_reservation": "Créer Réservation",
            "failed_load_clients": "Échec du chargement des clients",
            "failed_load_vehicles": "Échec du chargement des véhicules",
            "failed_load_reservations": "Échec du chargement des réservations",
            "success_delete_reservation": "Réservation supprimée avec succès",
            "error_delete_reservation": "Erreur lors de la suppression de la réservation",
            "searching": "Recherche en cours...",
            "results": "Résultats",
            "reservations_results_subtitle": "Liste des réservations selon vos critères de recherche",
            "try_modifying_filters": "Essayez de modifier vos critères de recherche",
            "start_reservation": "Démarrer la réservation",
            "january": "Janvier", "february": "Février", "march": "Mars", "april": "Avril", "may": "Mai", "june": "Juin",
            "july": "Juillet", "august": "Août", "september": "Septembre", "october": "Octobre", "november": "Novembre", "december": "Décembre",
            "sun": "Dim", "mon": "Lun", "tue": "Mar", "wed": "Mer", "thu": "Jeu", "fri": "Ven", "sat": "Sam",
            "in_progress_no_select": "En cours (non sélectionnable)",
            "pending_with_alert": "En attente (avec alerte)",
            "date_unavailable_in_progress": "Date non disponible - Réservation en cours",
            "pending_click_continue": "Réservation en attente - Cliquez pour continuer (avec alerte)",
            "select_time": "Sélectionner l'heure",
            "pending_date_warning": "⚠️ Attention: Cette date fait partie d'une réservation en attente. Voulez-vous continuer?",
            "client_required": "Client est requis",
            "vehicle_required": "Voiture est requise",
            "departure_km_invalid": "Kilométrage de départ invalide",
            "departure_date_required": "Date de départ est requise",
            "return_date_required": "Date de retour prévue est requise",
            "return_after_departure_error": "La date/heure de retour doit être après la date/heure de départ",
            "discount_range_error": "La remise doit être entre 0 et",
            "versement_min_error": "Le versement initial doit être supérieur à 0",
            "versement_max_error": "Le versement initial ne peut pas dépasser le total",
            "paid_mode_error": "Pour le mode 'payé', le montant payé doit égaler le total",
            "non_paid_mode_error": "Pour le mode 'non payé', le montant payé doit être 0",
            "not_defined": "Non défini",
            "at": "à",
            "error_creating_reservation": "Erreur lors de la création",
            "phone_short": "Tél",
            "upload_files": "Télécharger des fichiers",
            "upcoming_reservations": "Réservations à venir",
            "search_reservations": "Rechercher des réservations...",
            "filter_by_status": "Filtrer par statut",
            "filter_by_date": "Filtrer par date",
            "mark_as_confirmed": "Marquer comme Confirmée",
            "mark_as_cancelled": "Marquer comme Annulée",
            "mark_as_completed": "Marquer comme Terminée",
            "view_details": "Voir les Détails",
            "edit_reservation": "Modifier la Réservation",
            "delete_reservation": "Supprimer la Réservation",
            "confirm_delete_reservation": "Êtes-vous sûr de vouloir supprimer cette réservation ?",
            "reservation_id": "ID Réservation",
            "client_details": "Détails du Client",
            "vehicle_details": "Détails du Véhicule",
            "rental_period": "Période de Location",
            "pricing": "Tarification",
            "days": "jours",
            "day": "jour",
            "total_amount": "Montant Total",
            "paid_amount": "Montant Payé",
            "balance_due": "Solde Dû",
            "contract_generated": "Contrat généré avec succès",
            "generate_contract": "Générer le Contrat",
            "print_receipt": "Imprimer le Reçu",
            "no_reservations_found": "Aucune réservation trouvée",
            "all_reservations": "Toutes les Réservations",
            "reservation_history": "Historique des Réservations",
            "active_reservations": "Réservations Actives",
            "payment_status": "Statut de Paiement",
            "paid": "Payé",
            "partial": "Partiel",
            "unpaid": "Non payé",
            "loading_reservations": "Chargement des réservations...",
            "save_reservation": "Enregistrer la Réservation",
            "updating_reservation": "Mise à jour de la réservation...",
            "reservation_number": "Réservation #",
            "contract_number": "Contrat #",
            "pickup_location": "Lieu de départ",
            "return_location": "Lieu de retour",
            "notes": "Notes",
            "additional_services": "Services Additionnels",
            "insurance": "Assurance",
            "baby_seat": "Siège Bébé",
            "gps": "GPS",
            "additional_driver": "Conducteur Additionnel",
            "daily_rate": "Tarif Journalier",
            "extension": "Extension",
            "extend_reservation": "Prolonger la Réservation",
            "new_return_date": "Nouvelle Date de Retour",
            "cost": "Coût",
            "reason": "Raison",
            "apply": "Appliquer",
            "new_client": "Nouveau Client",
            "edit_client": "Modifier Client",
            "client_list": "Liste des Clients",
            "client_found": "client trouvé",
            "clients_found": "clients trouvés",
            "no_client_found": "Aucun client trouvé",
            "add_first_client_desc": "Commencez par ajouter votre premier client",
            "add_client_btn": "Ajouter un client",
            "client_col": "Client",
            "contact_col": "Contact",
            "type_col": "Type",
            "license_col": "Permis",
            "delete_client_title": "Supprimer le client",
            "delete_client_confirm": "Êtes-vous sûr de vouloir supprimer ce client? Cette action est irréversible.",
            "delete_success_client": "Client supprimé avec succès",
            "error_delete_client": "Erreur lors de la suppression du client",
            "personal_info": "Informations Personnelles",
            "main_driver": "Conducteur Principal",
            "second_driver": "Conducteur Secondaire",
            "last_name": "Nom",
            "first_name": "Prénom",
            "phone": "Téléphone",
            "address": "Adresse",
            "dob": "Date de naissance",
            "pob": "Lieu de naissance",
            "driving_license": "Permis de Conduire",
            "license_number": "Numéro de permis",
            "issue_date": "Date délivrance",
            "issue_place": "Lieu délivrance",
            "validity": "Validité",
            "issued_at": "Délivré à",
            "passport": "Passeport",
            "passport_number": "Numéro passeport",
            "passport_issue_date": "Date délivrance passeport",
            "passport_issue_place": "Lieu délivrance passeport",
            "license_photo": "Photo du permis",
            "click_to_upload_client": "Cliquez pour téléverser",
            "success_add_client": "Client ajouté avec succès !",
            "success_update_client": "Client modifié avec succès !",
            "full_dossier": "Dossier Complet",
            "sync_success": "Données synchronisées avec succès",
            "no_image_available": "Aucune image disponible",
            "modifier_le_dossier": "Modifier le Dossier",
            "currency": "DA",
            "modify": "Modifier",
            "save": "Enregistrer",
            "loading": "Chargement...",
            "error_loading": "Erreur lors du chargement",
            "action": "Action",
            "view_all": "Voir tout",
            "manage_reservation": "Gérer la réservation",
            "client_vehicle": "Client & Véhicule",
            "reservation_details": "Détails de la réservation",
            "dates_locations": "Dates & Lieux",
            "deposit_caution": "Versement & Caution",
            "saving": "Enregistrement...",
            "error_details": "Impossible de charger les détails.",
            "reservation_not_found": "Réservation non trouvée",
            "start_reservation_title": "Démarrer la Réservation",
            "client_info": "Informations Client",
            "vehicle_info": "Informations Véhicule",
            "locations": "Lieux",
            "dates_prices": "Dates & Tarifs",
            "agent": "Agent",
            "return_mileage": "Kilométrage de retour",
            "late_return_detected": "Retour en retard détecté",
            "early_return": "Retour anticipé",
            "total_adjustable": "Total (modifiable)",
            "full_payment_notice": "La réservation sera marquée comme payée en totalité",
            "overdue_status": "En retard",
            "rental_status": "Location",
            "returns_status": "Retours",
            "weekly": "Semaine",
            "monthly": "Mois",
            "unauthorized_access": "Accès non autorisé",
            "insufficient_permissions": "Vous n'avez pas les permissions nécessaires",
            "search_results_count": "résultat(s) trouvé(s)",
            "overdue_return": "Retour en retard",
            "success_update_reservation": "Réservation modifiée avec succès",
            "error_update_reservation": "Erreur lors de la modification de la réservation",
            "confirm_complete_reservation": "Êtes-vous sûr de vouloir clôturer cette réservation ?",
            "confirm_start_reservation": "Êtes-vous sûr de vouloir démarrer cette réservation ?",
            "payment_mode_modified": "Mode de paiement modifié",
            "total_increased_from": "Le total a augmenté de",
            "to": "à",
            "payment_mode_auto_changed": "Le mode de paiement a été automatiquement changé en 'Versement' avec un versement initial.",
            "date_unavailable": "Date non disponible",
            "continue": "Continuer",
            "confirm": "Confirmer",
            "client_required": "Client est requis",
            "vehicle_required": "Voiture est requise",
            "departure_km_invalid": "Kilométrage de départ invalide",
            "departure_date_required": "Date de départ est requise",
            "return_date_required": "Date de retour prévue est requise",
            "return_after_departure_error": "La date de retour doit être après le départ",
            "discount_range_error": "La remise doit être entre 0 et",
            "versement_min_error": "Le versement doit être supérieur à 0",
            "versement_max_error": "Le versement ne peut pas dépasser le total",
            "paid_mode_error": "Le montant doit égaler le total pour le mode 'payé'",
            "success_delete_photo": "Photo supprimée avec succès",
            "error_delete_photo": "Erreur lors de la suppression de la photo",
            "edit_reservation_ongoing": "Modifier Réservation en Cours",
            "edit_reservation_desc": "Mettez à jour les détails de la réservation existante",
            "select_client_placeholder": "-- Sélectionner un client --",
            "select_vehicle_placeholder": "-- Sélectionner un véhicule --",
            "search_client_or_enter": "Ou saisir un nom de client",
            "caution_rendu": "Caution rendu",
            "reservation_started": "Réservation démarrée",
            "status_now_in_progress": "Le statut est maintenant 'En cours'.",
            "error_loading_details": "Erreur lors du chargement des détails",
            "loading_details": "Chargement des détails...",
            "client_info": "Informations Client",
            "vehicle_info": "Informations Véhicule",
            "locations": "Lieux",
            "dates_tarifs": "Dates & Tarifs",
            "km_departure_label": "KM Départ",
            "start_reservation_btn": "Démarrer la réservation",
            "close_reservation_title": "Clôturer la réservation",
            "return_mileage_label": "Kilométrage de retour",
            "late_return_detected": "Retour en retard détecté. Veuillez saisir le montant des frais de retard :",
            "early_return_detected": "Retour anticipé. Nouveau total :",
            "new_total": "Nouveau total",
            "total_modifiable": "Total (modifiable)",
            "reservation_fully_paid": "La réservation sera marquée comme payée en totalité",
            "remaining_before_closing": "Reste à payer avant clôture",
            "close_reservation_btn": "Clôturer",
            "file": "fichier",
            "files": "fichiers",
            "selected": "sélectionné(s)",
            "valid_km_return_error": "Veuillez saisir un kilométrage de retour valide.",
            "weekly_caps": "HEBDOMADAIRE",
            "monthly_caps": "MENSUEL",
            "filters": "Filtres",
            "filter_reservations": "Filtrer les réservations",
            "clear_all": "Effacer tout",
            "all_clients": "Tous les clients",
            "all_vehicles": "Toutes les voitures",
            "departure_date_from": "Date de départ (de)",
            "departure_date_to": "Date de départ (à)",
            "results_description": "Liste des réservations selon vos critères de recherche",
            "try_different_filters": "Essayez de modifier vos critères de recherche",
            "departure_point": "Départ:",
            "return_point": "Retour:",
            "confirm_delete_title": "Êtes-vous sûr ?",
            "confirm_delete_text": "Cette réservation sera définitivement supprimée.",
            "deleted_title": "Supprimée !",
            "deleted_success_text": "La réservation a été supprimée avec succès.",
            "delete_error_text": "Une erreur est survenue lors de la suppression de la réservation.",
            "delete_error_short": "Erreur lors de la suppression de la réservation.",
            "confirm_late_closing": "🚨 La voiture est retournée en retard. Confirmez-vous la clôture avec frais ?",
            "complete_error": "❌ Impossible de clôturer la réservation.",
            "analytics_dashboard": "Tableau de bord analytique",
            "fleet_stats_desc": "Statistiques complètes de votre flotte automobile",
            "today": "Aujourd'hui",
            "this_week": "Cette semaine",
            "this_month": "Ce mois",
            "this_year": "Cette année",
            "financial_stats": "Statistiques financières",
            "performance": "Performance",
            "encaissements": "Encaissements",
            "decaissements": "Décaissements",
            "net_balance": "Solde Net",
            "expense_income_ratio": "Ratio Dépense/Entrée",
            "financial_evolution": "Évolution financière",
            "cumulative_balance": "Solde cumulé",
            "max_inflow_day": "Jour avec encaissement maximal",
            "max_outflow_day": "Jour avec décaissement maximal",
            "on_the": "Le",
            "record": "Record",
            "reservation_stats": "Statistiques de réservation",
            "top_5_rented_cars": "Top 5 voitures louées",
            "locations_count": "locations",
            "top_5_least_used_cars": "5 voitures les moins utilisées",
            "top_5_vip_clients": "Top 5 clients VIP",
            "average_rental_duration": "Durée moyenne de location",
            "cancellation_rate": "Taux d'annulation",
            "avg_on_all_reservations": "Moyenne sur toutes les réservations",
            "percentage_cancelled_reservations": "Pourcentage des réservations annulées",
            "loading_stats": "Chargement des statistiques...",
            "increase": "Augmentation",
            "decrease": "Diminution",
            "no_data_available": "Aucune donnée disponible",
            "no_records_found_section": "Aucun enregistrement trouvé pour cette section.",
            "finance_management": "Gestion des finances",
            "new_transaction": "Nouvelle transaction",
            "edit_transaction": "Modifier la transaction",
            "transaction_added_success": "Transaction ajoutée avec succès !",
            "transaction_updated_success": "Transaction mise à jour avec succès !",
            "transaction_deleted_success": "Transaction supprimée avec succès !",
            "confirm_delete_transaction": "Êtes-vous sûr de vouloir supprimer cette transaction ?",
            "amount_required": "Le montant est obligatoire et doit être un nombre valide.",
            "type_date_required": "Le type et la date sont obligatoires.",
            "electricity": "Électricité",
            "water": "Eau",
            "internet": "Internet",
            "cleaning_lady": "Femme de médage",
            "agent_payment": "Paiement de l'agent",
            "reservation": "Réservation",
            "investment": "Investissement",
            "other": "Autre",
            "justification": "Justificatif",
            "view_justification": "Voir justificatif",
            "download_success": "Téléchargement réussi",
            "download_failed": "Téléchargement échoué",
            "no_transaction_found": "Aucune transaction trouvée.",
            "amount_da": "Montant (DA)",
            "receipt": "Reçu",
            "all": "Tous",
            "showing_results": "Affichage de {{start}} à {{end}} sur {{total}} résultats",
            "previous": "Précédent",
            "next": "Suivant",

            // CarTransactions page
            "transactions_management": "Gestion des Transactions",
            "manage_vehicle_transactions": "Gérez les revenus et dépenses de votre véhicule",
            "statistics_btn": "Statistiques",
            "categories_btn": "Catégories",
            "select_vehicle_label": "Sélectionner un véhicule",
            "choose_vehicle": "Choisir un véhicule",
            "total_label": "Total",
            "search_transactions": "Rechercher transactions (description, catégorie...)",
            "all_types": "Tous les types",
            "encaissement_label": "Encaissements",
            "decaissement_label": "Décaissements",
            "all_categories": "Toutes les catégories",
            "start_date": "Date de début",
            "end_date": "Date de fin",
            "reset": "Réinitialiser",
            "transactions_title": "Transactions",
            "no_vehicle_selected_msg": "Aucun véhicule sélectionné",
            "select_vehicle_to_view": "Veuillez sélectionner un véhicule pour voir ses transactions",
            "no_transactions_msg": "Aucune transaction",
            "add_first_transaction_desc": "Commencez par ajouter votre première transaction pour ce véhicule",
            "add_transaction_btn": "Ajouter une transaction",
            "no_search_results": "Aucun résultat",
            "no_matching_transactions": "Aucune transaction ne correspond à vos critères de recherche",
            "reset_transaction_filters": "Réinitialiser les filtres",
            "date_col": "Date",
            "type_col": "Type",
            "category_col": "Catégorie",
            "amount_col": "Montant",
            "actions_col": "Actions",
            "uncategorized": "Non catégorisé",
            "edit_transaction_btn": "Éditer",
            "delete_transaction_btn": "Supprimer",
            "delete_transaction_title": "Supprimer la transaction",
            "delete_transaction_confirm": "Êtes-vous sûr de vouloir supprimer cette transaction? Cette action est irréversible.",
            "encaissement_type": "Encaissement",
            "decaissement_type": "Décaissement",
            "transaction_form_title_new": "Nouvelle Transaction",
            "transaction_form_title_edit": "Modifier la Transaction",
            "transaction_type_label": "Type de transaction *",
            "transaction_category_label": "Catégorie",
            "transaction_amount_label": "Montant (DA) *",
            "transaction_description_label": "Description",
            "transaction_date_label": "Date *",
            "transaction_submit_create": "Ajouter la Transaction",
            "transaction_submit_update": "Modifier la Transaction",
            "creating": "Création...",
            "updating": "Mise à jour...",
            "manage_categories_title_modal": "Gestion des Catégories",
            "total_transactions": "transactions totales",
            "page_label": "Page",

            // Historique page
            "reservations_management_hist": "Gestion des Réservations",
            "filter_reservations_hist": "Filtrer les réservations",
            "clear_all_filters": "Effacer tout",
            "all_statuses": "Tous les statuts",
            "status_pending": "En attente",
            "status_in_progress": "En cours",
            "status_done": "Terminée",
            "status_canceled": "Annulée",
            "status_overdue": "En retard",
            "search_btn": "Rechercher",
            "searching_label": "Recherche en cours...",
            "results_title": "Résultats",
            "results_subtitle": "Liste des réservations selon vos critères de recherche",
            "no_reservations_found_hist": "Aucune réservation trouvée",
            "try_modify_filters": "Essayez de modifier vos critères de recherche",
            "id_col": "ID",
            "vehicle_col": "Voiture",
            "dates_col": "Dates",
            "price_col": "Prix",
            "date_departure_label": "Départ:",
            "date_return_label": "Retour:",
            "total_price_label": "Total:",
            "paid_label": "Payé:",
            "view_details_btn": "Voir détails",

            // Account page
            "my_account": "Mon Compte",
            "save_btn": "Sauvegarder",
            "current_password": "Mot de passe actuel",
            "new_password": "Nouveau mot de passe",
            "change_password": "Changer le mot de passe",
            "updating_password": "En cours...",
            "update_password_btn": "Mettre à jour le mot de passe",
            "agency_info": "Informations de l'agence",
            "agency_name": "Nom de l'agence",
            "location_label": "Lieu",
            "phone1": "Téléphone 1",
            "phone2": "Téléphone 2",
            "email": "Email",
            "employee_management": "Gestion des Employés",
            "new_employee": "Nouvel Employé",
            "no_employees_found": "Aucun employé trouvé",
            "username_col": "Nom d'utilisateur",
            "role_col": "Rôle",
            "created_at_col": "Date de création",
            "edit_employee": "Modifier l'employé",
            "delete_employee": "Supprimer l'employé",
            "confirm_delete_employee": "Êtes-vous sûr de vouloir supprimer cet employé ?",
            "employee_updated": "Employé mis à jour avec succès",
            "employee_created": "Employé créé avec succès",
            "employee_deleted": "Employé supprimé avec succès",
            "error_loading_data": "Erreur lors du chargement des données",
            "error_loading_employees": "Erreur lors du chargement des employés",
            "password_fields_required": "Veuillez remplir les deux champs",
            "password_updated": "Mot de passe mis à jour avec succès",
            "info_updated": "Informations mises à jour",
            "username_updated": "Nom d'utilisateur mis à jour",
            "update_error": "Erreur lors de la mise à jour",
            "operation_error": "Erreur lors de l'opération",
            "password_label": "Mot de passe",
            "role_employee": "Employé",
            "role_admin": "Administrateur",
            "creating_label": "En cours..."
        }
    },
    ar: {
        translation: {
            "dashboard": "لوحة القيادة",
            "vehicles": "إدارة السيارات",
            "clients": "الزبائن",
            "reservations": "الحجوزات",
            "rental": "التأجير",
            "history": "الأرشيف",
            "maintenance": "الصيانة",
            "calendar": "التقويم",
            "finance": "المالية",
            "vehicle_stats": "إحصائيات السيارات",
            "general_stats": "إحصائيات عامة",
            "account": "الحساب",
            "logout": "تسجيل الخروج",
            "admin": "مدير",
            "employee": "موظف",
            "total_fleet": "إجمالي الأسطول",
            "active_alerts": "تنبيهات نشطة",
            "revenue_7d": "إيرادات (7 أيام)",
            "global_balance": "الرصيد الإجمالي",
            "revenue_growth": "نمو الإيرادات (آخر 7 أيام)",
            "fleet_status": "حالة الأسطول",
            "quick_actions": "إجراءات سريعة",
            "maintenance_report": "تقرير تنبيهات الصيانة",
            "urgent": "عاجل",
            "medium": "متوسط",
            "overdue": "متأخر",
            "departures": "مغادرة",
            "returns": "عودة",
            "available": "متاح",
            "reserved": "محجوز",
            "ready_to_use": "سيارات جاهزة للاستخدام",
            "need_attention": "عاجلة تتطلب اهتماماً",
            "received_today": "المدفوعات المستلمة اليوم",
            "balance_diff": "الفرق بين الدخل والخرج",
            "refresh": "تحديث",
            "new_reservation": "حجز جديد",
            "insurance": "التأمين",
            "oil_change": "تغيير الزيت",
            "tech_visit": "الفحص التقني",
            "expired": "منتهي",
            "late": "متأخر",
            "overdue_short": "متجاوز",
            "remaining_days": "أيام متبقية",
            "remaining_km": "كلم متبقية",
            "details": "تفاصيل الحجز",
            "close": "إغلاق",
            "client_dossier": "ملف الزبون",
            "assigned_vehicle": "السيارة المخصصة",
            "planning": "التخطيط",
            "departure": "المغادرة",
            "return": "العودة",
            "km_departure": "كلم الانطلاق",
            "status": "الحالة",
            "fleet_status": "حالة الأسطول",
            "maintenance_management": "إدارة الصيانة",
            "maintenance_desc": "تتبع وتخطيط صيانة أسطول سياراتك",
            "technical_visits": "الزيارات التقنية",
            "insurances": "التأمينات",
            "oil_changes": "تغيير الزيت",
            "distributions": "أحزمة التوقيت",
            "current_mileage": "المسافة المقطوعة الحالية",
            "search_vehicle": "البحث عن سيارة...",
            "all_vehicles_filter": "جميع السيارات",
            "expired_deadlines": "المواعيد منتهية",
            "recorded_vehicles": "السيارات المسجلة",
            "upcoming_visits": "الزيارات القادمة",
            "expired_insurances": "التأمينات المنتهية",
            "required_oil_changes": "تغيير الزيت المطلوب",
            "no_vehicle_found_maintenance": "لم يتم العثور على سيارات",
            "add_vehicles_desc_maintenance": "ابدأ بإضافة سياراتك لإدارة صيانتها",
            "date_derniere_visite_tech": "آخر فحص تقني",
            "date_prochaine_visite_tech": "الفحص التقني القادم",
            "assurance_compagnie": "شركة التأمين",
            "numero_police_assurance": "رقم البوليسة",
            "date_expiration_assurance": "تاريخ الانتهاء",
            "date_derniere_vidange": "آخر تغيير للزيت",
            "kilometrage_derniere_vidange": "مسافة آخر تغيير زيت",
            "kilometrage_prochaine_vidange": "مسافة تغيير الزيت القادمة",
            "date_remplacement_distribution": "تاريخ تغيير الحزام",
            "kilometrage_remplacement_distribution": "مسافة تغيير الحزام",
            "kilometrage_prochain_distribution": "مسافة تغيير الحزام القادمة",
            "recorded_vehicles": "السيارات المسجلة",
            "manage_vehicles": "إدارة المركبات",
            "fleet_mgmt_desc": "إدارة أسطول سياراتك بكفاءة",
            "total": "الإجمالي",
            "unavailable": "غير متاح",
            "new_transaction": "معاملة جديدة",
            "manage_categories": "إدارة الفئات",
            "new_vehicle": "سيارة جديدة",
            "search_vehicles_placeholder": "البحث عن السيارات (العلامة التجارية، الموديل، اللوحة، الهيكل...)",
            "all_status": "جميع الحالات",
            "sort_by_brand": "ترتيب حسب العلامة التجارية",
            "sort_by_price": "ترتيب حسب السعر",
            "sort_by_year": "ترتيب حسب السنة",
            "search_results": "نتائج البحث",
            "vehicle_found": "سيارة موجودة",
            "vehicles_found": "سيارات موجودة",
            "no_vehicle_found": "لم يتم العثور على سيارة",
            "add_first_vehicle_desc": "ابدأ بإضافة سيارتك الأولى",
            "add_vehicle": "إضافة سيارة",
            "no_results": "لا توجد نتائج",
            "no_matching_vehicles": "لا توجد سيارة تطابق معايير البحث الخاصة بك",
            "reset_filters": "إعادة تعيين المرشحات",
            "delete_vehicle_title": "حذف السيارة",
            "delete_vehicle_confirm": "هل أنت متأكد من أنك تريد حذف هذه السيارة؟ هذا الإجراء لا يمكن التراجع عنه وسيحذف جميع البيانات المرتبطة.",
            "cancel": "إلغاء",
            "delete": "حذف",
            "per_day": "/يوم",
            "unknown_brand": "علامة مجهولة",
            "unknown_model": "موديل مجهول",
            "unknown_version": "إصدار مجهول",
            "not_available_short": "غ/م",
            "unknown_color": "لون مجهول",
            "auto": "أوتوماتيك",
            "manual": "يدوي",
            "seats": "مقاعد",
            "week": "أسبوع:",
            "month": "شهر:",
            "reason": "السبب:",
            "photos": "صور",
            "edit": "تعديل",
            "essence": "بنزين",
            "diesel": "ديزل",
            "gpl": "غاز",
            "electric": "كهرباء",
            "hybrid": "هجين",
            "edit_vehicle": "تعديل السيارة",
            "general_info": "معلومات عامة",
            "tech_specs": "المواصفات التقنية",
            "vehicle_condition": "حالة السيارة",
            "pricing": "التسعير",
            "insurance_info": "التأمين",
            "history_info": "الأرشيف",
            "maintenance_info": "الصيانة",
            "chassis_number": "رقم الهيكل",
            "license_plate": "رقم اللوحة",
            "brand": "العلامة التجارية",
            "model": "الموديل",
            "version_label": "الإصدار",
            "year": "السنة",
            "color": "اللون",
            "genre": "النوع",
            "body_type": "الهيكل",
            "weight": "الوزن",
            "payload": "الحمولة",
            "prev_registration": "التسجيل السابق",
            "fuel": "الوقود",
            "transmission": "علبة التروس",
            "seats_count": "عدد المقاعد",
            "doors_count": "عدد الأبواب",
            "mileage": "المسافة المقطوعة",
            "power": "القوة",
            "mech_state": "الحالة الميكانيكية",
            "body_state": "حالة الهيكل",
            "suspension_state": "حالة التعليق",
            "tires_state": "حالة الإطارات",
            "state_comment": "تعليق على الحالة",
            "daily_price": "سعر الإيجار اليومي",
            "weekly_price": "سعر الإيجار الأسبوعي",
            "monthly_price": "سعر الإيجار الشهري",
            "avail_status": "حالة التوفر",
            "unavail_reason": "سبب عدم التوفر",
            "insurance_company": "شركة التأمين",
            "policy_number": "رقم البوليسة",
            "expiration_date": "تاريخ الانتهاء",
            "registration_date": "تاريخ أول استخدام",
            "last_tech_visit": "آخر فحص تقني",
            "next_tech_visit": "الفحص التقني القادم",
            "last_oil_change": "آخر تغيير للزيت",
            "oil_change_mileage": "مسافة تغيير الزيت",
            "next_oil_change_mileage": "مسافة تغيير الزيت القادمة",
            "distrib_replacement_date": "تاريخ تغيير الحزام",
            "distrib_replacement_mileage": "مسافة تغيير الحزام",
            "next_distrib_mileage": "مسافة تغيير الحزام القادمة",
            "equipment": "التجهيزات",
            "photos_docs": "الصور والمستندات",
            "vehicle_photo": "صورة السيارة",
            "registration_card": "البطاقة الرمادية",
            "insurance_doc": "التأمين",
            "extra_photos": "صور إضافية",
            "click_to_upload": "انقر للرفع",
            "drag_drop": "أو اسحب وأفلت",
            "allowed_formats": "PNG, JPG, JPEG",
            "files_selected": "ملفات تم اختيارها",
            "required_fields_notice": "حقول إجبارية",
            "save_success": "تمت إضافة السيارة بنجاح!",
            "update_success": "تم تحديث السيارة بنجاح!",
            "save_error": "حدث خطأ أثناء حفظ السيارة",
            "delete_photo_error": "حدث خطأ أثناء حذف الصورة",
            "comment_placeholder": "تعليقات على حالة السيارة...",
            "unavail_placeholder": "سبب عدم التوفر...",
            "click_to_upload_short": "انقر للرفع",

            // General
            "add": "إضافة",
            "adding": "جاري الإضافة...",

            "back": "رجوع",
            "print": "طباعة",
            "print_voucher": "طباعة وصل الدفع",
            "created_on": "أنشئ في",
            "actual_return": "العودة الفعلية",
            "km_details": "تفاصيل الكيلومترات",
            "distance_traveled": "المسافة المقطوعة",
            "late_penalty": "غرامة التأخير",
            "delete_photo": "حذف الصورة",
            "choose_photos": "اختيار الصور",
            "view_client_details": "عرض تفاصيل الزبون",
            "view_vehicle_details": "عرض تفاصيل المركبة",
            "no_client_info": "لا توجد معلومات عن الزبون",
            "no_vehicle_info": "لا توجد معلومات عن المركبة",

            // VoitureGallery
            "gallery_full": "المعرض الكامل",
            "no_photos": "لا توجد صور متاحة",
            "main_photo_label": "الصورة الرئيسية",
            "registration_card_label": "البطاقة الرمادية",
            "insurance_label": "التأمين",
            "extra_photo_label": "صورة إضافية",
            "supplementary": "إضافي",
            "thumbnail": "مصغرة",

            // AddEquipement
            "add_equipment_btn": "إضافة معدات",
            "equipment_placeholder": "اسم المعدات",
            "success_add_equip": "تم إضافة المعدات بنجاح",
            "error_add_equip": "خطأ أثناء إضافة المعدات",

            // CategoryManager
            "manage_categories_title": "إدارة الفئات",
            "category_desc": "تنظيم أنواع المعاملات الخاصة بك",
            "edit_mode_active": "وضع التحرير نشط",
            "category_name_label": "اسم الفئة",
            "category_placeholder": "مثال: النقل، الطعام...",
            "description_label": "الوصف",
            "description_placeholder": "وصف اختياري...",
            "save_category": "حفظ الفئة",
            "add_category": "إضافة فئة",
            "loading_categories": "جاري تحميل الفئات...",
            "no_categories_found": "لم يتم العثور على فئات",
            "empty_categories_desc": "ابدأ بإضافة فئتك الأولى",
            "existing_categories": "الفئات الموجودة",
            "protected_categories_count": "فئات محمية",
            "name_col": "الاسم",
            "description_col": "الوصف",
            "actions_col": "الإجراءات",
            "edit_btn": "تعديل",
            "delete_btn": "حذف",
            "confirm_delete_title": "هل أنت متأكد؟",
            "confirm_delete_text": "هل تريد حقاً حذف هذه الفئة؟",
            "delete_success": "تم حذف الفئة",
            "delete_error": "خطأ أثناء الحذف",
            "protected_cat_error": "هذه الفئة محمية ولا يمكن تعديلها أو حذفها",
            "reserved_cat_error": "اسم الفئة هذا محجوز ولا يمكن إنشاؤه",
            "yes_delete": "نعم، احذف",
            "error": "خطأ",
            "warning": "تحذير",
            "success": "نجاح",
            "unexpected_server_response": "استجابة غير متوقعة من الخادم",

            // Client Module
            "search_clients_placeholder": "البحث عن الزبائن (الاسم، البريد، الهاتف...)",
            "client_type_label": "نوع الزبون",
            "all_types": "جميع الأنواع",
            "particulier": "فردي",
            "entreprise": "شركة",

            // Reservation Module
            "reservations_management": "إدارة الحجوزات",
            "create_new_reservation": "إنشاء حجز جديد",
            "fill_reservation_details": "املأ تفاصيل الحجز",
            "success_reservation_created": "تم إنشاء الحجز بنجاح",
            "error_reservation_creation": "خطأ في إنشاء الحجز",
            "understood": "مفهوم",
            "reservation_list": "قائمة الحجوزات",
            "select_vehicle": "اختر المركبة",
            "select_client": "اختر الزبون",
            "departure_date": "تاريخ الانطلاق",
            "return_date": "تاريخ العودة",
            "total_price": "السعر الإجمالي",
            "advance_payment": "تسبيق",
            "remaining_payment": "المبلغ المتبقي",
            "status": "الحالة",
            "pending": "في الانتظار",
            "reservation_calendar": "تقويم الحجوزات",
            "filters": "الفلاتر",
            "all_statuses_filter": "كل الحالات",
            "today": "اليوم",
            "month_view": "شهر",
            "week_view": "أسبوع",
            "day_view": "يوم",
            "list_view": "قائمة",
            "in_progress": "قيد التنفيذ",
            "confirmed": "مؤكد",
            "cancelled": "ملغى",
            "completed": "مكتمل",
            "today_reservations": "حجوزات اليوم",
            "errors_to_fix": "أخطاء يجب تصحيحها",
            "client_vehicle_info": "معلومات العميل والمركبة",
            "search_client_placeholder": "ابحث عن عميل حسب الاسم أو الهاتف",
            "new_client_name_placeholder": "أو أدخل اسم عميل (عميل جديد)",
            "selected_client": "العميل المختار",
            "client_history": "سجل العميل",
            "departure_date_time": "تاريخ ووقت المغادرة",
            "return_date_time": "تاريخ ووقت العودة المتوقع",
            "select_departure_first": "يرجى اختيار تاريخ المغادرة أولاً",
            "base_price_day": "السعر الأساسي (يومي)",
            "number_of_days": "عدد الأيام",
            "total_price_before_discount": "السعر الإجمالي قبل الخصم",
            "departure_location": "مكان المغادرة",
            "return_location": "مكان العودة",
            "departure_mileage": "كيلومترات المغادرة",
            "pricing_payment": "التسعير والدفع",
            "discount": "الخصم",
            "total_after_discount": "الإجمالي بعد الخصم",
            "initial_versement": "الدفعة الأولى",
            "deposit_notes": "العربون والملاحظات",
            "deposit": "العربون",
            "deposit_returned": "تم إرجاع العربون",
            "remaining_amount": "المبلغ المتبقي",
            "notes_placeholder": "ملاحظات إضافية أو تفاصيل الحجز",
            "description": "الوصف",
            "photos_optional": "الصور (اختياري)",
            "create_reservation": "إنشاء حجز",
            "failed_load_clients": "فشل تحميل العملاء",
            "failed_load_vehicles": "فشل تحميل المركبات",
            "failed_load_reservations": "فشل تحميل الحجوزات",
            "success_delete_reservation": "تم حذف الحجز بنجاح",
            "error_delete_reservation": "خطأ في حذف الحجز",
            "searching": "جاري البحث...",
            "results": "النتائج",
            "reservations_results_subtitle": "قائمة الحجوزات بناءً على معايير البحث الخاصة بك",
            "try_modifying_filters": "حاول تعديل معايير البحث الخاصة بك",
            "start_reservation": "بدء الحجز",
            "january": "جانفي", "february": "فيفري", "march": "مارس", "april": "أفريل", "may": "ماي", "june": "جوان",
            "july": "جويلية", "august": "أوت", "september": "سبتمبر", "october": "أكتوبر", "november": "نوفمبر", "december": "ديسمبر",
            "sun": "الأحد", "mon": "الاثنين", "tue": "الثلاثاء", "wed": "الأربعاء", "thu": "الخميس", "fri": "الجمعة", "sat": "السبت",
            "in_progress_no_select": "قيد التنفيذ (غير قابل للاختيار)",
            "pending_with_alert": "قيد الانتظار (مع تنبيه)",
            "date_unavailable_in_progress": "التاريخ غير متاح - هناك حجز قيد التنفيذ",
            "pending_click_continue": "حجز قيد الانتظار - انقر للمتابعة (مع تنبيه)",
            "select_time": "اختر الوقت",
            "pending_date_warning": "⚠️ تحذير: هذا التاريخ جزء من حجز قيد الانتظار. هل تريد المتابعة؟",
            "client_required": "العميل مطلوب",
            "vehicle_required": "المركبة مطلوبة",
            "departure_km_invalid": "كيلومترات المغادرة غير صالحة",
            "departure_date_required": "تاريخ المغادرة مطلوب",
            "return_date_required": "تاريخ العودة مطلوب",
            "return_after_departure_error": "يجب أن يكون تاريخ/وقت العودة بعد تاريخ/وقت المغادرة",
            "discount_range_error": "يجب أن يكون الخصم بين 0 و",
            "versement_min_error": "يجب أن تكون الدفعة الأولى أكبر من 0",
            "versement_max_error": "لا يمكن أن تتجاوز الدفعة الأولى الإجمالي",
            "paid_mode_error": "لوضع 'مدفوع' ، يجب أن يكون المبلغ المدفوع مساوياً للإجمالي",
            "non_paid_mode_error": "لوضع 'غير مدفوع' ، يجب أن يكون المبلغ المدفوع 0",
            "not_defined": "غير محدد",
            "at": "في",
            "error_creating_reservation": "خطأ أثناء الإنشاء",
            "phone_short": "الهاتف",
            "upload_files": "تحميل الملفات",
            "upcoming_reservations": "الحجوزات القادمة",
            "search_reservations": "البحث عن الحجوزات...",
            "filter_by_status": "تصفية حسب الحالة",
            "filter_by_date": "تصفية حسب التاريخ",
            "mark_as_confirmed": "تحديد كمؤكد",
            "mark_as_cancelled": "تحديد كاملغى",
            "mark_as_completed": "تحديد كمكتمل",
            "view_details": "عرض التفاصيل",
            "edit_reservation": "تعديل الحجز",
            "delete_reservation": "حذف الحجز",
            "confirm_delete_reservation": "هل أنت متأكد من حذف هذا الحجز؟",
            "reservation_id": "رقم الحجز",
            "client_details": "تفاصيل الزبون",
            "vehicle_details": "تفاصيل المركبة",
            "rental_period": "فترة الإيجار",
            "pricing": "التسعير",
            "days": "أيام",
            "day": "يوم",
            "total_amount": "المبلغ الإجمالي",
            "paid_amount": "المبلغ المدفوع",
            "balance_due": "المبلغ المتبقي",
            "contract_generated": "تم إنشاء العقد بنجاح",
            "generate_contract": "إنشاء العقد",
            "print_receipt": "طباعة الإيصال",
            "no_reservations_found": "لم يتم العثور على حجوزات",
            "all_reservations": "جميع الحجوزات",
            "reservation_history": "سجل الحجوزات",
            "active_reservations": "الحجوزات النشطة",
            "payment_status": "حالة الدفع",
            "paid": "مدفوع",
            "partial": "جزئي",
            "unpaid": "غير مدفوع",
            "loading_reservations": "جارٍ تحميل الحجوزات...",
            "save_reservation": "حفظ الحجز",
            "updating_reservation": "جارٍ تحديث الحجز...",
            "reservation_number": "حجز رقم",
            "contract_number": "عقد رقم",
            "pickup_location": "مكان الاستلام",
            "return_location": "مكان العودة",
            "notes": "ملاحظات",
            "additional_services": "خدمات إضافية",
            "insurance": "التأمين",
            "baby_seat": "مقعد طفل",
            "gps": "نظام تحديد المواقع",
            "additional_driver": "سائق إضافي",
            "daily_rate": "السعر اليومي",
            "extension": "تمديد",
            "extend_reservation": "تمديد الحجز",
            "new_return_date": "تاريخ عودة جديد",
            "cost": "التكلفة",
            "reason": "السبب",
            "apply": "تطبيق",
            "new_client": "زبون جديد",
            "edit_client": "تعديل الزبون",
            "client_list": "قائمة الزبائن",
            "client_found": "زبون موجود",
            "clients_found": "زبائن موجودون",
            "no_client_found": "لم يتم العثور على زبائن",
            "add_first_client_desc": "ابدأ بإضافة زبونك الأول",
            "add_client_btn": "إضافة زبون",
            "client_col": "الزبون",
            "contact_col": "الاتصال",
            "type_col": "النوع",
            "license_col": "الرخصة",
            "delete_client_title": "حذف الزبون",
            "delete_client_confirm": "هل أنت متأكد من حذف هذا الزبون؟ هذا الإجراء لا يمكن التراجع عنه.",
            "delete_success_client": "تم حذف الزبون بنجاح",
            "error_delete_client": "خطأ أثناء حذف الزبون",
            "personal_info": "المعلومات الشخصية",
            "main_driver": "السائق الرئيسي",
            "second_driver": "السائق الثانوي",
            "last_name": "اللقب",
            "first_name": "الاسم",
            "phone": "الهاتف",
            "address": "العنوان",
            "dob": "تاريخ الميلاد",
            "pob": "مكان الميلاد",
            "driving_license": "رخصة السياقة",
            "license_number": "رقم الرخصة",
            "issue_date": "تاريخ الإصدار",
            "issue_place": "مكان الإصدار",
            "validity": "الصلاحية",
            "issued_at": "صادر في",
            "passport": "جواز السفر",
            "passport_number": "رقم جواز السفر",
            "passport_issue_date": "تاريخ إصدار الجواز",
            "passport_issue_place": "مكان إصدار الجواز",
            "license_photo": "صورة الرخصة",
            "click_to_upload_client": "انقر للتحميل",
            "success_add_client": "تم إضافة الزبون بنجاح!",
            "success_update_client": "تم تعديل الزبون بنجاح!",
            "full_dossier": "ملف كامل",
            "sync_success": "تم مزامنة البيانات بنجاح",
            "no_image_available": "لا توجد صورة متاحة",
            "modifier_le_dossier": "تعديل الملف",
            "currency": "د.ج",
            "modify": "تعديل",
            "save": "حفظ",
            "loading": "جاري التحميل...",
            "error_loading": "خطأ أثناء التحميل",
            "action": "الإجراء",
            "view_all": "عرض الكل",
            "manage_reservation": "إدارة الحجز",
            "client_vehicle": "الزبون والمركبة",
            "reservation_details": "تفاصيل الحجز",
            "dates_locations": "التواريخ والأماكن",
            "deposit_caution": "الدفعة والعربون",
            "saving": "جاري الحفظ...",
            "error_details": "تعذر تحميل التفاصيل",
            "reservation_not_found": "الحجز غير موجود",
            "start_reservation_title": "بدء الحجز",
            "client_info": "معلومات الزبون",
            "vehicle_info": "معلومات المركبة",
            "locations": "الأماكن",
            "dates_prices": "التواريخ والأسعار",
            "agent": "الوكيل",
            "return_mileage": "كيلومترات العودة",
            "late_return_detected": "تم اكتشاف عودة متأخرة",
            "early_return": "عودة مبكرة",
            "total_adjustable": "الإجمالي (قابل للتعديل)",
            "full_payment_notice": "سيتم وضع علامة على الحجز كمدفوع بالكامل",
            "overdue_status": "متأخر",
            "rental_status": "إيجار",
            "returns_status": "عوائد",
            "weekly": "أسبوعي",
            "monthly": "شهري",
            "unauthorized_access": "وصول غير مصرح به",
            "insufficient_permissions": "ليس لديك أذونات كافية",
            "search_results_count": "نتائج موجودة",
            "overdue_return": "عودة متأخرة",
            "success_update_reservation": "تم تحديث الحجز بنجاح",
            "error_update_reservation": "خطأ في تحديث الحجز",
            "confirm_complete_reservation": "هل أنت متأكد من أنك تريد إنهاء هذا الحجز؟",
            "confirm_start_reservation": "هل أنت متأكد من أنك تريد بدء هذا الحجز؟",
            "payment_mode_modified": "تم تعديل وضع الدفع",
            "total_increased_from": "ارتفع الإجمالي من",
            "to": "إلى",
            "payment_mode_auto_changed": "تم تغيير وضع الدفع تلقائيًا إلى 'الدفعة' مع إيداع أولي.",
            "date_unavailable": "التاريخ غير متاح",
            "continue": "متابعة",
            "confirm": "تأكيد",
            "client_required": "الزبون مطلوب",
            "vehicle_required": "المركبة مطلوبة",
            "departure_km_invalid": "كيلومترات المغادرة غير صالحة",
            "departure_date_required": "تاريخ المغادرة مطلوب",
            "return_date_required": "تاريخ العودة مبني مطلوب",
            "return_after_departure_error": "يجب أن يكون تاريخ العودة بعد تاريخ المغادرة",
            "discount_range_error": "الخصم بين 0 و",
            "versement_min_error": "يجب أن تكون الدفعة أكبر من 0",
            "versement_max_error": "لا يمكن أن تتجاوز الدفعة الإجمالي",
            "paid_mode_error": "يجب أن يساوي المبلغ الإجمالي لوضع 'مدفوع'",
            "success_delete_photo": "تم حذف الصورة بنجاح",
            "error_delete_photo": "خطأ في حذف الصورة",
            "edit_reservation_ongoing": "تعديل الحجز الحالي",
            "edit_reservation_desc": "تحديث تفاصيل الحجز الحالي",
            "select_client_placeholder": "-- اختر الزبون --",
            "select_vehicle_placeholder": "-- اختر المركبة --",
            "search_client_or_enter": "أو أدخل اسم الزبون",
            "description": "الوصف",
            "reservation_started": "بدأ الحجز",
            "status_now_in_progress": "الحالة الآن 'قيد التنفيذ'.",
            "error_loading_details": "خطأ في تحميل التفاصيل",
            "loading_details": "جاري تحميل التفاصيل...",
            "client_info": "معلومات العميل",
            "vehicle_info": "معلومات المركبة",
            "locations": "المواقع",
            "dates_tarifs": "التواريخ والأسعار",
            "km_departure_label": "كيلومتر الانطلاق",
            "start_reservation_btn": "بدء الحجز",
            "close_reservation_title": "إغلاق الحجز",
            "return_mileage_label": "كيلومتر العودة",
            "late_return_detected": "تم كشف تأخير في العودة. يرجى إدخال مبلغ رسوم التأخير:",
            "early_return_detected": "تم كشف عودة مبكرة. الإجمالي الجديد:",
            "new_total": "الإجمالي الجديد",
            "total_modifiable": "الإجمالي (قابل للتعديل)",
            "reservation_fully_paid": "سيتم تحديد الحجز كمدفوع بالكامل",
            "remaining_before_closing": "المتبقي للدفع قبل الإغلاق",
            "close_reservation_btn": "إغلاق الحجز",
            "file": "ملف",
            "files": "ملفات",
            "selected": "تم اختيارها",
            "valid_km_return_error": "يرجى إدخال كيلومتر عودة صحيح.",
            "weekly_caps": "إسبوعي",
            "monthly_caps": "شهري",
            "filters": "الفلاتر",
            "filter_reservations": "فلترة الحجوزات",
            "clear_all": "مسح الكل",
            "all_clients": "كل الزبائن",
            "all_vehicles": "كل السيارات",
            "departure_date_from": "تاريخ المغادرة (من)",
            "departure_date_to": "تاريخ المغادرة (إلى)",
            "results_description": "قائمة الحجوزات بناءً على معايير البحث الخاصة بك",
            "try_different_filters": "حاول تعديل معايير البحث الخاصة بك",
            "departure_point": "المغادرة:",
            "return_point": "العودة:",
            "confirm_delete_title": "هل أنت متأكد؟",
            "confirm_delete_text": "سيتم حذف هذا الحجز بشكل نهائي.",
            "deleted_title": "تم الحذف!",
            "deleted_success_text": "تم حذف الحجز بنجاح.",
            "delete_error_text": "حدث خطأ أثناء حذف الحجز.",
            "delete_error_short": "خطأ أثناء حذف الحجز.",
            "confirm_late_closing": "🚨 عادت السيارة متأخرة. هل تؤكد الإغلاق مع الرسوم؟",
            "complete_error": "❌ تعذر إكمال الحجز.",
            "analytics_dashboard": "لوحة القيادة التحليلية",
            "fleet_stats_desc": "إحصائيات كاملة لأسطول سياراتك",
            "today": "اليوم",
            "this_week": "هذا الأسبوع",
            "this_month": "هذا الشهر",
            "this_year": "هذه السنة",
            "financial_stats": "الإحصائيات المالية",
            "performance": "الأداء",
            "encaissements": "المداخيل",
            "decaissements": "المصاريف",
            "net_balance": "الرصيد الصافي",
            "expense_income_ratio": "نسبة المصاريف/المداخيل",
            "financial_evolution": "التطور المالي",
            "cumulative_balance": "الرصيد التراكمي",
            "max_inflow_day": "يوم بأعلى دخل",
            "max_outflow_day": "يوم بأعلى صرف",
            "on_the": "في",
            "record": "رقم قياسي",
            "reservation_stats": "إحصائيات الحجز",
            "top_5_rented_cars": "أفضل 5 سيارات مؤجرة",
            "locations_count": "تأجيرات",
            "top_5_least_used_cars": "5 سيارات أقل استخداماً",
            "top_5_vip_clients": "أفضل 5 زبائن VIP",
            "average_rental_duration": "متوسط مدة التأجير",
            "cancellation_rate": "معدل الإلغاء",
            "avg_on_all_reservations": "متوسط جميع الحجوزات",
            "percentage_cancelled_reservations": "نسبة الحجوزات الملغاة",
            "loading_stats": "جاري تحميل الإحصائيات...",
            "increase": "زيادة",
            "decrease": "نقصان",
            "no_data_available": "لا توجد بيانات متاحة",
            "no_records_found_section": "لم يتم العثور على سجلات لهذا القسم.",
            "finance_management": "إدارة المالية",
            "new_transaction": "معاملة جديدة",
            "edit_transaction": "تعديل المعاملة",
            "transaction_added_success": "تم إضافة المعاملة بنجاح!",
            "transaction_updated_success": "تم تحديث المعاملة بنجاح!",
            "transaction_deleted_success": "تم حذف المعاملة بنجاح!",
            "confirm_delete_transaction": "هل أنت متأكد أنك تريد حذف هذه المعاملة؟",
            "amount_required": "المبلغ مطلوب ويجب أن يكون رقماً صحيحاً.",
            "type_date_required": "النوع والتاريخ مطلوبان.",
            "electricity": "كهرباء",
            "water": "ماء",
            "internet": "إنترنت",
            "cleaning_lady": "عاملة نظافة",
            "agent_payment": "دفع الوكيل",
            "reservation": "حجز",
            "investment": "استثمار",
            "other": "آخر",
            "justification": "تبرير",
            "view_justification": "عرض التبرير",
            "download_success": "تم التحميل بنجاح",
            "download_failed": "فشل التحميل",
            "no_transaction_found": "لم يتم العثور على معاملات.",
            "amount_da": "المبلغ (د.ج)",
            "receipt": "وصل",
            "all": "الكل",
            "showing_results": "عرض {{start}} إلى {{end}} من {{total}} نتيجة",
            "previous": "السابق",
            "next": "التالي",

            // CarTransactions page
            "transactions_management": "إدارة المعاملات",
            "manage_vehicle_transactions": "إدارة إيرادات ومصاريف سيارتك",
            "statistics_btn": "إحصائيات",
            "categories_btn": "الفئات",
            "select_vehicle_label": "اختر سيارة",
            "choose_vehicle": "اختر سيارة",
            "total_label": "الإجمالي",
            "search_transactions": "البحث في المعاملات (الوصف، الفئة...)",
            "all_types": "جميع الأنواع",
            "encaissement_label": "المداخيل",
            "decaissement_label": "المصاريف",
            "all_categories": "جميع الفئات",
            "start_date": "تاريخ البداية",
            "end_date": "تاريخ النهاية",
            "reset": "إعادة تعيين",
            "transactions_title": "المعاملات",
            "no_vehicle_selected_msg": "لم يتم اختيار سيارة",
            "select_vehicle_to_view": "يرجى اختيار سيارة لعرض معاملاتها",
            "no_transactions_msg": "لا توجد معاملات",
            "add_first_transaction_desc": "ابدأ بإضافة أول معاملة لهذه السيارة",
            "add_transaction_btn": "إضافة معاملة",
            "no_search_results": "لا توجد نتائج",
            "no_matching_transactions": "لا توجد معاملة تطابق معايير البحث",
            "reset_transaction_filters": "إعادة تعيين الفلاتر",
            "date_col": "التاريخ",
            "type_col": "النوع",
            "category_col": "الفئة",
            "amount_col": "المبلغ",
            "actions_col": "الإجراءات",
            "uncategorized": "غير مصنف",
            "edit_transaction_btn": "تعديل",
            "delete_transaction_btn": "حذف",
            "delete_transaction_title": "حذف المعاملة",
            "delete_transaction_confirm": "هل أنت متأكد من حذف هذه المعاملة؟ هذا الإجراء لا يمكن التراجع عنه.",
            "encaissement_type": "دخل",
            "decaissement_type": "صرف",
            "transaction_form_title_new": "معاملة جديدة",
            "transaction_form_title_edit": "تعديل المعاملة",
            "transaction_type_label": "نوع المعاملة *",
            "transaction_category_label": "الفئة",
            "transaction_amount_label": "المبلغ (د.ج) *",
            "transaction_description_label": "الوصف",
            "transaction_date_label": "التاريخ *",
            "transaction_submit_create": "إضافة المعاملة",
            "transaction_submit_update": "تحديث المعاملة",
            "creating": "جاري الإنشاء...",
            "updating": "جاري التحديث...",
            "manage_categories_title_modal": "إدارة الفئات",
            "total_transactions": "معاملة إجمالية",
            "page_label": "صفحة",

            // Historique page
            "reservations_management_hist": "إدارة الحجوزات",
            "filter_reservations_hist": "تصفية الحجوزات",
            "clear_all_filters": "مسح الكل",
            "all_statuses": "جميع الحالات",
            "status_pending": "في الانتظار",
            "status_in_progress": "جارٍ",
            "status_done": "منتهي",
            "status_canceled": "ملغى",
            "status_overdue": "متأخر",
            "search_btn": "بحث",
            "searching_label": "جارٍ البحث...",
            "results_title": "النتائج",
            "results_subtitle": "قائمة الحجوزات بناءً على معايير البحث",
            "no_reservations_found_hist": "لم يتم العثور على حجوزات",
            "try_modify_filters": "حاول تعديل معايير البحث",
            "id_col": "المعرف",
            "vehicle_col": "السيارة",
            "dates_col": "التواريخ",
            "price_col": "السعر",
            "date_departure_label": "المغادرة:",
            "date_return_label": "العودة:",
            "total_price_label": "الإجمالي:",
            "paid_label": "المدفوع:",
            "view_details_btn": "عرض التفاصيل",

            // Account page
            "my_account": "حسابي",
            "save_btn": "حفظ",
            "current_password": "كلمة المرور الحالية",
            "new_password": "كلمة المرور الجديدة",
            "change_password": "تغيير كلمة المرور",
            "updating_password": "جاري...",
            "update_password_btn": "تحديث كلمة المرور",
            "agency_info": "معلومات الوكالة",
            "agency_name": "اسم الوكالة",
            "location_label": "الموقع",
            "phone1": "هاتف 1",
            "phone2": "هاتف 2",
            "email": "البريد الإلكتروني",
            "employee_management": "إدارة الموظفين",
            "new_employee": "موظف جديد",
            "no_employees_found": "لم يتم العثور على موظفين",
            "username_col": "اسم المستخدم",
            "role_col": "الدور",
            "created_at_col": "تاريخ الإنشاء",
            "edit_employee": "تعديل الموظف",
            "delete_employee": "حذف الموظف",
            "confirm_delete_employee": "هل أنت متأكد من حذف هذا الموظف؟",
            "employee_updated": "تم تحديث الموظف بنجاح",
            "employee_created": "تم إنشاء الموظف بنجاح",
            "employee_deleted": "تم حذف الموظف بنجاح",
            "error_loading_data": "خطأ في تحميل البيانات",
            "error_loading_employees": "خطأ في تحميل الموظفين",
            "password_fields_required": "يرجى ملء كلا الحقلين",
            "password_updated": "تم تحديث كلمة المرور بنجاح",
            "info_updated": "تم تحديث المعلومات",
            "username_updated": "تم تحديث اسم المستخدم",
            "update_error": "خطأ في التحديث",
            "operation_error": "خطأ في العملية",
            "password_label": "كلمة المرور",
            "role_employee": "موظف",
            "role_admin": "مدير",
            "creating_label": "جاري..."
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'fr',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
